<mat-form-field class="keyword-controller">
  <mat-label>Keywords</mat-label>
  <mat-chip-grid #chipGrid aria-label="Keyword selection" class="chip-grid">
    @for (keyword of selectedKeywords(); track keyword.id) {
      <mat-chip-row
        (removed)="removeKeyword(keyword)"
        class="chip"
        [matTooltip]="keyword.typeDescription || keyword.type"
        [attr.aria-label]="keyword.title">
        <span class="chip-content">
          @if (keyword.label) {
            <span class="chip-label">{{ keyword.label }}</span>
          }
          <span class="chip-title">{{ keyword.title }}</span>
        </span>
        <button matChipRemove [attr.aria-label]="'remove ' + keyword.title">
          <mat-icon fontIcon="cancel"/>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>
  <input
    #keywordInput
    name="currentKeyword"
    placeholder="Search keywords..."
    [formControl]="keywordInputControl"
    [matChipInputFor]="chipGrid"
    [matAutocomplete]="auto"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    (matChipInputTokenEnd)="addKeyword($event)"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayKeyword"
    (optionSelected)="selectedKeyword($event); keywordInput.value = ''">
    @if (filteredKeywords().length === 0) {
      <mat-option disabled>
        @if (keywordInputValue()) {
          No keywords found
        } @else {
          Start typing to search
        }
      </mat-option>
    } @else {
      @for (keyword of filteredKeywords(); track keyword.id) {
        <mat-option [value]="keyword">
          <div class="keyword-option">
            <div class="keyword-option-main">
              @if (keyword.label) {
                <span class="keyword-label">{{ keyword.label }}</span>
              }
              <span class="keyword-title">{{ keyword.title }}</span>
            </div>
            @if (keyword.typeDescription || keyword.type) {
              <div class="keyword-option-type">{{ keyword.typeDescription || keyword.type }}</div>
            }
          </div>
        </mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
